export default __webpack_public_path__ + "static/burjkhalifa-4f72b375d367cc736594c09cc9082c87.webp";